import {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'

import {useViewImageContext} from './Fields/ViewField/ViewLand/Images/ViewImageContext'
import {useMapLegendContext} from './Fields/ViewField/ViewLand/Helpers/MapLegend'

const isReportsRoute = (pathname) => pathname === '/gis/reports' || pathname.startsWith('/gis/reports/')

// The map stays mounted between GIS routes, so leaving a land for Reports must
// also clear its overlays. Report subroutes can manage their own map state.
const ReportsMapCleanup = () => {
  const {pathname} = useLocation()
  const imageContext = useViewImageContext()
  const legendContext = useMapLegendContext()
  const previousPathname = useRef(pathname)
  const cleanup = useRef({imageContext, legendContext})
  cleanup.current = {imageContext, legendContext}

  useEffect(() => {
    if (!isReportsRoute(previousPathname.current) && isReportsRoute(pathname)) {
      cleanup.current.legendContext.deleteAll()
      cleanup.current.imageContext.closeAllImages()
    }
    previousPathname.current = pathname
  }, [pathname])

  return null
}

export default ReportsMapCleanup
